'use client'

import { Disclosure, Transition } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/20/solid'

const FAQs = ({
  faqs,
  labels
}: {
  labels: any
  faqs: { ANSWER: string; QUESTION: string }[]
}) => {
  return (
    <div className="max-w-7xl px-6 py-8 sm:py-10 lg:px-8 lg:py-12">
      <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
        <h2 className="text-center text-2xl font-medium leading-10 tracking-tight text-brand-blue">
          {labels.FAQS_TITLE}
        </h2>
        <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <Disclosure as="div" key={faq.QUESTION} className="pt-6">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-brand-blue">
                      <span className="text-base font-normal leading-7">
                        {faq.QUESTION}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <MinusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        ) : (
                          <PlusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Disclosure.Panel as="dd" className="mt-2 pr-1">
                      <p className="text-base font-light leading-7 text-gray-500">
                        {faq.ANSWER}
                      </p>
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  )
}

export default FAQs
